// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"FooterLinks_footerLinks__1W7E1","listItem":"FooterLinks_listItem__1kfbp","list":"FooterLinks_list__1fo-0"};